import React, { useContext, useEffect, useState } from 'react';

//context and hooks
import { ListContext } from '@/context/ListContext';
import { MainMenuListContext } from '@/context/MainMenuListContext';
// import { ListContributorViewOptions } from  '@/components/elements/lists/ViewToggle';

import  '@/css/lists/mainmenulist.scss';



const UseMainMenuScreen = () => {
    const [widgetPanelOpen, setWidgetPanelOpen] = useState<boolean>(false)
    const {hasEditorRights, isCombinedFeedEnabled} = useContext(ListContext)
    const {viewOption, setViewOption, notificationDetails, downloadContentReportUrl} = useContext(MainMenuListContext)

    useEffect(() => {
        (window as any).functions = {...window.functions, closeWidgetPanel: () => setWidgetPanelOpen(false)}
    },[])

    useEffect(() => {
        if (document.querySelector('.panelGroup.widgetPanels')) {
            (document.querySelector('.panelGroup.widgetPanels') as HTMLDivElement).style.display = 'none';
        }
        if (document.querySelector('.mainContentPanel.panel')) {
            (document.querySelector('.mainContentPanel.panel') as HTMLDivElement).style.width = '816px'
        }
        // setViewOption(ListContributorViewOptions.AllItems)
    },[]);

    return {hasEditorRights, widgetPanelOpen, setWidgetPanelOpen, viewOption, setViewOption, notificationDetails, downloadContentReportUrl, isCombinedFeedEnabled}
}

export default UseMainMenuScreen